import SpecialStoreDetail from './SpecialStoreDetail'

export default SpecialStoreDetail
